module.exports = __webpack_public_path__ + "static/media/8.b4fcc50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/悬浮窗/8.png
// module id = 1658
// module chunks = 0